import React, { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';

const TextReasoningConditions = ({ value, onChange }) => {
    const [textReasoning, setTextReasoning] = useState(value.text_reasoning || '');

    useEffect(() => {
        onChange({
            text_reasoning: textReasoning
        });
    }, [textReasoning, onChange]);

    return (
        <Box>
            <TextField
                label="Text Reasoning (Captioning)"
                value={textReasoning}
                onChange={(e) => setTextReasoning(e.target.value)}
                fullWidth
                variant="outlined"
                margin="dense"
                placeholder="Reasoning text must contain something that will trigger an alarm"
                multiline
                rows={2}
            />
        </Box>
    );
};

export default TextReasoningConditions;
